import { render, staticRenderFns } from "./pendiente.vue?vue&type=template&id=59556e3a&scoped=true"
import script from "./pendiente.vue?vue&type=script&lang=js"
export * from "./pendiente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59556e3a",
  null
  
)

export default component.exports